import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76afe01e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-popup-container__left" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "info-popup-container__navigation-svg--back" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "info-popup-container__order" }
const _hoisted_6 = { class: "info-popup-container__navigation-title" }
const _hoisted_7 = {
  key: 0,
  class: "info-popup-container__navigation-info"
}
const _hoisted_8 = { class: "info-popup-container__navigation-date account-order__item-date" }
const _hoisted_9 = { class: "info-popup-container__navigation-status account-order__item-status account-order__item-status--white" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "info-popup-container__navigation-svg--close" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "modal__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_final_modal = _resolveComponent("vue-final-modal")!

  return (_openBlock(), _createBlock(_component_vue_final_modal, _mergeProps(_ctx.$attrs, {
    classes: "modal-container",
    "content-class": "modal-content"
  }), {
    default: _withCtx(({ close, params }) => [
      _createElementVNode("div", {
        class: _normalizeClass(["info-popup-container__navigation", {'info-popup-container__navigation--order': _ctx.date && _ctx.status}])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.back)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "info-popup-container__navigation-body",
                onClick: close
              }, _hoisted_4, 8, _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.title), 1),
            (_ctx.date && _ctx.status)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.date), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.status), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", {
          class: "info-popup-container__navigation-body",
          onClick: close
        }, _hoisted_12, 8, _hoisted_10)
      ], 2),
      _createElementVNode("div", _hoisted_13, [
        _renderSlot(_ctx.$slots, "content", { params: params }, undefined, true)
      ])
    ]),
    _: 3
  }, 16))
}